import { Form } from 'react-bootstrap';

const Ascom = props => {
  return (
    <>
      <Form.Group controlId="formSubCategoria" className="mt-4">
        <Form.Label>*Subcategoria:</Form.Label>
        <Form.Select
          className="border border-secondary"
          required
          name="formSubCategoria"
          onChange={e => props.handleSubcategoria(e)}
        >
          <option value="">Selecione a Subcategoria</option>
          {props.getCategorias?.find(categoria => categoria.id === 14)?.subcategoria.map(item => (
            <option key={item.nome} value={item.nome}>{item.nome}</option>
          ))}
        </Form.Select>
      </Form.Group>
    </>
  );
};

export default Ascom;
